import { styled } from '@stitches/react'

export const RankedDragAndDropListContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  width: '100%',
  maxWidth: '500px',
  margin: '0 auto',
})

export const SortableList = styled('ul', {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '0',
  listStyle: 'none',
})

export const RankIcon = styled('div', {
  display: ' flex',
  width: ' 24px',
  height: ' 24px',
  padding: ' 8px',
  flexDirection: ' column',
  justifyContent: ' center',
  alignItems: ' center',
  gap: ' 8px',
  borderRadius: ' 1000px',
  background: '$primary-500',
  color: 'white',
  variants: {
    visible: {
      true: {
        opacity: '1',
      },
      false: {
        opacity: '0',
      },
    },
  },
})
